import React from 'react';
// import PDF_CV from '../../assets/cv.pdf';

const CV = () => {
  return (
    <div className="cv">
      {/* <a href={PDF_CV} download className="btn">
        Download CV
      </a> */}
      <a href="#contact" className="btn btn-primary">
        Let's Talk
      </a>
    </div>
  );
};

export default CV;
